import usePipedriveOrganization from 'hooks/usePipedriveOrganization'

import { Cell } from '../../../../components/ReusableComponents/Table'
import styles from './InvoicePipedriveLinkCell.module.scss'

const InvoicePipedriveLinkCell = ({ displayId }) => {
  const { isLoading, error, openOrganization } = usePipedriveOrganization(displayId)

  return (
    <Cell className={styles.linkCell}>
      <button
        type="button"
        className={styles.openButton}
        onClick={openOrganization}
        disabled={isLoading || !displayId}
        aria-label="Open Pipedrive organization"
        title={error || 'Open Pipedrive organization'}
      >
        {isLoading ? 'Opening...' : 'Open in Pipedrive'}
      </button>
      {error ? <span className={styles.errorText}>{error}</span> : null}
    </Cell>
  )
}

export default InvoicePipedriveLinkCell
